import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomControlComponent } from './custom-control.component';
import { MyMaterialModule } from 'src/app/app.material';
import { FormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { AddMetadataValueDialogModule } from '../../employer/add-metadata-value-dialog/add-metadata-value-dialog.module';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MyMaterialModule,
    FlexLayoutModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AddMetadataValueDialogModule,
    TranslocoModule
  ],
  declarations: [
    CustomControlComponent
  ],
  exports: [CustomControlComponent]
})
export class CustomControlModule { }
